import * as React from "react";
import { Button, Confirm } from "react-admin";

export const ButtonWithConfirm = ({ label, startIcon, confirmMessage, onConfirm }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button //
        label={label}
        startIcon={startIcon}
        onClick={handleClick}
        color="primary"
        variant="contained"
      />

      <Confirm //
        isOpen={open}
        title={confirmMessage}
        onConfirm={handleConfirm}
        onClose={handleClose}
        confirmColor="primary"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
      />
    </React.Fragment>
  );
};
